// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Ja-Z","vLegacy":"SelectSecondary_vLegacy__3E7_J","error":"SelectSecondary_error__1Ot0O","disabled":"SelectSecondary_disabled__2apIE"};